import { render, staticRenderFns } from "./Post.vue?vue&type=template&id=b6aa7178&lang=pug&"
import script from "./Post.vue?vue&type=script&lang=js&"
export * from "./Post.vue?vue&type=script&lang=js&"
import style0 from "./Post.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/rain/projects/themes/achernar/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b6aa7178')) {
      api.createRecord('b6aa7178', component.options)
    } else {
      api.reload('b6aa7178', component.options)
    }
    module.hot.accept("./Post.vue?vue&type=template&id=b6aa7178&lang=pug&", function () {
      api.rerender('b6aa7178', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/Post.vue"
export default component.exports